"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noDocumentConverted = exports.ipcDocs = void 0;
exports.ipcDocs = [
    {
        patientMrn: null,
        dateOfService: null,
        providerNumber: null,
        placerOrderNumber: null,
        fillerOrderNumber: null,
        encounterNumber: null,
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "BEDSIDE_PRO",
        documentCategory: "NOTE",
        messageCategory: null,
        documentStatus: null,
        documentName: null,
        documentDescription: null,
        mimeType: "application/pdf",
        contentLength: 183204,
        externalId: "405222",
        documentGuid: {
            uuid: "edfc0b42-caba-4697-a8a8-ee7f79a67978"
        },
        documentId: 41194876,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: "ea939201-b02c-43cc-a417-241bf363755f",
        additionalInfo: null,
        hl7MessageDirection: null,
        hl7MessageType: null,
        id: 41194876
    },
    {
        patientMrn: null,
        dateOfService: null,
        providerNumber: null,
        placerOrderNumber: null,
        fillerOrderNumber: null,
        encounterNumber: null,
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "BEDSIDE_PRO",
        documentCategory: "NOTE",
        messageCategory: null,
        documentStatus: null,
        documentName: null,
        documentDescription: null,
        mimeType: "text/plain",
        contentLength: 32072,
        externalId: "405222",
        documentGuid: {
            uuid: "ea073470-642a-4564-bf46-76eb6266d686"
        },
        documentId: 41194878,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: "ea939201-b02c-43cc-a417-241bf363755f",
        additionalInfo: null,
        hl7MessageDirection: null,
        hl7MessageType: null,
        id: 41194878
    },
    {
        patientMrn: null,
        dateOfService: null,
        providerNumber: null,
        placerOrderNumber: null,
        fillerOrderNumber: null,
        encounterNumber: null,
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "BEDSIDE_PRO",
        documentCategory: "NOTE",
        messageCategory: null,
        documentStatus: null,
        documentName: null,
        documentDescription: null,
        mimeType: "text/html",
        contentLength: 32072,
        externalId: "405222",
        documentGuid: {
            uuid: "ea073470-642a-4564-bf46-76eb6266d686"
        },
        documentId: 41194876,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: "ea939201-b02c-43cc-a417-241bf363755f",
        additionalInfo: null,
        hl7MessageDirection: null,
        hl7MessageType: null,
        id: 41194876
    },
    {
        patientMrn: null,
        dateOfService: null,
        providerNumber: null,
        placerOrderNumber: null,
        fillerOrderNumber: null,
        encounterNumber: null,
        encounterGuid: null,
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "BEDSIDE_PRO",
        documentCategory: "NOTE",
        messageCategory: null,
        documentStatus: null,
        documentName: null,
        documentDescription: null,
        mimeType: "text/html",
        contentLength: 32072,
        externalId: "405222",
        documentGuid: {
            uuid: "ea073470-642a-4564-bf46-76eb6266d686"
        },
        documentId: 41194878,
        messageId: null,
        sourceName: null,
        sourceType: null,
        serviceLine: null,
        businessKey: "ea939201-b02c-43cc-a417-241bf363755f",
        additionalInfo: null,
        hl7MessageDirection: null,
        hl7MessageType: null,
        id: 41194877
    }
];
exports.noDocumentConverted = [
    {
        patientMrn: "15274806",
        dateOfService: 1716422400000,
        providerNumber: null,
        placerOrderNumber: null,
        fillerOrderNumber: null,
        encounterNumber: "718147596",
        encounterGuid: {
            uuid: "471e77fa-6e42-4b28-9c18-d7c9b72cd602"
        },
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "BEDSIDE_PRO",
        documentCategory: "NOTE",
        messageCategory: "HL7",
        documentStatus: null,
        documentName: null,
        documentDescription: "Progress Notes",
        mimeType: "application/rtf",
        contentLength: 14640,
        externalId: "fe23d88d-32e8-4eca-b1a1-1ffb4db4f05f",
        documentGuid: {
            uuid: "3ce5ecdd-4991-466e-8c22-e3622eb5f781"
        },
        documentId: 66006576,
        messageId: "206865947_MDM",
        sourceName: null,
        sourceType: "HL7",
        serviceLine: "BSP",
        businessKey: "fe23d88d-32e8-4eca-b1a1-1ffb4db4f05f",
        additionalInfo: null,
        noteType: "PN",
        noteSpecialty: null,
        claimEditSpecialty: null,
        uniqueDocumentNumber: "4361746175",
        id: 66006576,
        hl7MessageDirection: "INBOUND",
        hl7MessageType: "MDM"
    },
    {
        patientMrn: "15274806",
        dateOfService: 1716422400000,
        providerNumber: null,
        placerOrderNumber: null,
        fillerOrderNumber: null,
        encounterNumber: "718147596",
        encounterGuid: {
            uuid: "471e77fa-6e42-4b28-9c18-d7c9b72cd602"
        },
        observationRequestGuid: null,
        observationResultGuid: null,
        documentType: "BEDSIDE_PRO",
        documentCategory: "NOTE",
        messageCategory: "HL7",
        documentStatus: null,
        documentName: null,
        documentDescription: "Progress Notes",
        mimeType: "text/plain",
        contentLength: 1550,
        externalId: "fe23d88d-32e8-4eca-b1a1-1ffb4db4f05f",
        documentGuid: {
            uuid: "a5d815be-1365-4184-8f03-f47c17b295d0"
        },
        documentId: 66006580,
        messageId: "206865947_MDM",
        sourceName: null,
        sourceType: "HL7",
        serviceLine: "BSP",
        businessKey: "fe23d88d-32e8-4eca-b1a1-1ffb4db4f05f",
        additionalInfo: null,
        noteType: "PN",
        noteSpecialty: null,
        claimEditSpecialty: null,
        uniqueDocumentNumber: "4361746175",
        id: 66006580,
        hl7MessageDirection: "INBOUND",
        hl7MessageType: "MDM"
    }
];
//# sourceMappingURL=metadata.js.map